import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MessageService } from '../../../services/message-service/message.service';
import { GruppenService } from '../gruppen.service';
import { Haendler } from '../../stammdaten/haendler/haendler';
import { Gruppe } from '../classes/gruppe';
import { UntypedFormControl } from '@angular/forms';
import { HttpParams } from '@angular/common/http';
import { GruppeReklamationPdfHaendlerAuswahlDialogOutput } from './classes/gruppe-reklamation-pdf-haendler-auswahl-dialog-output';
import { Empfaenger } from '../../pdf-viewer/kiene-pdf-viewer/classes/empfaenger';
import { KieneUtils } from '../../../utils/KieneUtils';

@Component({
    selector: 'kiene-gruppe-reklamation-pdf-haendler-auswahl-dialog',
    templateUrl: './gruppe-reklamation-pdf-haendler-auswahl-dialog.component.html',
    styleUrls: ['./gruppe-reklamation-pdf-haendler-auswahl-dialog.component.scss'],
})
export class GruppeReklamationPdfHaendlerAuswahlDialogComponent implements OnInit {
    haendler: Haendler[] = [];
    betriebskontakte: any[] = [];
    haendlerCtrl: UntypedFormControl = new UntypedFormControl();
    betriebskontaktCtrl: UntypedFormControl = new UntypedFormControl();
    isLoading = true;
    gruppe: Gruppe;
    alleHaendler = new Haendler();
    alleBetriebskontakte: any = {};

    constructor(
        public dialogRef: MatDialogRef<GruppeReklamationPdfHaendlerAuswahlDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: Gruppe,
        private messageService: MessageService,
        private gruppenService: GruppenService,
    ) {
        this.gruppe = data;
        this.ladeHaendlerFuerGruppe();
        this.ladeBetriebskontakteFuerGruppe();
    }

    ngOnInit(): void {}

    private ladeHaendlerFuerGruppe() {
        this.gruppenService.ladeViehhaendlerFuerGruppe(this.gruppe).subscribe({
            next: resp => {
                this.haendler = resp.records;
                this.haendlerCtrl.setValue(this.alleHaendler);
                this.checkLoadingComplete();
            },
            error: err => {
                this.messageService.errorMessage('Fehler beim Laden der Händler!', err);
                this.checkLoadingComplete();
            },
        });
    }

    private ladeBetriebskontakteFuerGruppe() {
        this.gruppenService.ladeBetriebskontakteFuerGruppe(this.gruppe).subscribe({
            next: resp => {
                this.betriebskontakte = resp.records;
                this.betriebskontaktCtrl.setValue(this.alleBetriebskontakte);
                this.checkLoadingComplete();
            },
            error: err => {
                this.messageService.errorMessage('Fehler beim Laden der Betriebskontakte!', err);
                this.checkLoadingComplete();
            },
        });
    }

    private checkLoadingComplete() {
        if (this.haendler.length >= 0 && this.betriebskontakte.length >= 0) {
            this.isLoading = false;
        }
    }

    compareHaendler(h1: Haendler, h2: Haendler) {
        return h1 && h2 && KieneUtils.sameId(h1.viehhaendler_id, h2.viehhaendler_id);
    }

    compareBetriebskontakt(b1: any, b2: any) {
        return b1 && b2 && KieneUtils.sameId(b1.betriebskontakt_haendler_id, b2.betriebskontakt_haendler_id);
    }

    close() {
        const output = new GruppeReklamationPdfHaendlerAuswahlDialogOutput();
        const haendler: Haendler = this.haendlerCtrl.value;
        const betriebskontakt: any = this.betriebskontaktCtrl.value;
        let params = new HttpParams();

        if (haendler && haendler.viehhaendler_id) {
            params = params.set('viehhaendler_id', haendler.viehhaendler_id);
            if (haendler.email) {
                output.empfaenger = new Empfaenger(haendler.email, haendler.name, false);
            }
        } else if (betriebskontakt && betriebskontakt.betriebskontakt_haendler_id) {
            params = params.set('betriebskontakt_haendler_id', betriebskontakt.betriebskontakt_haendler_id);
            if (betriebskontakt.email) {
                output.empfaenger = new Empfaenger(betriebskontakt.email, betriebskontakt.name, false);
            }
        }

        output.params = params;
        this.dialogRef.close(output);
    }

    sendePdfAnAlleHaendler() {
        this.gruppenService
            .sendePdfAnAlleHaendler(this.gruppe?.gruppe_id)
            .subscribe({
                next: () => this.messageService.infoMessage('Die E-Mails werden im Hintergrund versandt.'),
                error: error => this.messageService.errorMessage('Fehler beim Versenden der E-Mails!', error),
            });
    }

    isEmailVersandMoeglich() {
        const haendlerMitEmail = this.haendler?.some(haendler => KieneUtils.isNNoU(haendler.email));
        const betriebskontakteMitEmail = this.betriebskontakte?.some(betriebskontakt =>
            KieneUtils.isNNoU(betriebskontakt.email),
        );
        return haendlerMitEmail || betriebskontakteMitEmail;
    }
}
